var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { "align-end": "", "justify-end": "" } },
    [
      _c("v-text-field", {
        attrs: {
          "align-end": "",
          flat: "",
          label: _vm.$t("searchPlaceholder")
        },
        model: {
          value: _vm.searchValue,
          callback: function($$v) {
            _vm.searchValue = $$v
          },
          expression: "searchValue"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5ede28f3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ede28f3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SearchTextFiled.vue
// module id = null
// module chunks = 